"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AsHtml", {
  enumerable: true,
  get: function () {
    return _React.default;
  }
});
Object.defineProperty(exports, "environments", {
  enumerable: true,
  get: function () {
    return _environments.environments;
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function () {
    return _Text.get;
  }
});
Object.defineProperty(exports, "getTranslationsUrl", {
  enumerable: true,
  get: function () {
    return _Applanga.getTranslationsUrl;
  }
});
Object.defineProperty(exports, "load", {
  enumerable: true,
  get: function () {
    return _Applanga.load;
  }
});
Object.defineProperty(exports, "render", {
  enumerable: true,
  get: function () {
    return _React.render;
  }
});

var _Applanga = require("./Applanga");

var _React = _interopRequireWildcard(require("./React"));

var _Text = require("./Text");

var _environments = require("./environments");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }